import { state } from '../state.js';

function _createRecentPhotoItem(photo, handlers = {}) {
    const onSelect = handlers.onSelect;
    const onHide = handlers.onHide;

    const item = document.createElement('div');
    item.className = 'trivia-thumb recent-source-item';
    item.dataset.sourceId = String(photo.id || '');
    item.setAttribute('role', 'button');
    item.tabIndex = 0;
    if (state.selectedSourcePhotoId && state.selectedSourcePhotoId === photo.id) {
        item.classList.add('is-selected');
    }

    const tile = document.createElement('div');
    tile.className = 'history-tile recent-source-tile';

    const img = document.createElement('img');
    img.loading = 'lazy';
    img.decoding = 'async';
    img.src = photo.thumb_url || photo.full_url || '';
    img.alt = photo.original_filename || photo.stored_filename || 'Recent source photo';

    const label = document.createElement('div');
    label.className = 'meta';
    const name = document.createElement('span');
    name.className = 'name';
    name.textContent = photo.original_filename || photo.stored_filename || 'source';
    name.title = name.textContent;
    label.appendChild(name);

    tile.appendChild(img);
    item.appendChild(tile);
    item.appendChild(label);

    const delBtn = document.createElement('button');
    delBtn.type = 'button';
    delBtn.className = 'del-btn';
    delBtn.innerText = '✕';
    delBtn.title = 'Hide photo';
    delBtn.setAttribute('aria-label', 'Hide photo');
    delBtn.onclick = (e) => {
        e.stopPropagation();
        if (typeof onHide === 'function') onHide(photo);
    };
    tile.appendChild(delBtn);

    const selectItem = () => {
        if (typeof onSelect === 'function') onSelect(photo);
    };
    item.onclick = selectItem;
    item.onkeydown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            selectItem();
        }
    };

    return item;
}

export function setRecentPhotoSelection(sourceId) {
    const strip = document.getElementById('recentPhotosStrip');
    if (!strip) return;
    const selectedId = sourceId ? String(sourceId) : '';
    const items = strip.querySelectorAll('.recent-source-item');
    items.forEach((item) => {
        const isSelected = Boolean(selectedId) && item.dataset.sourceId === selectedId;
        item.classList.toggle('is-selected', isSelected);
    });
}

export function upsertRecentPhoto(photo, handlers = {}) {
    if (!photo || !photo.id) return;
    const strip = document.getElementById('recentPhotosStrip');
    if (!strip) return;
    const empty = document.getElementById('recentPhotosEmpty');
    const existing = strip.querySelector(`.recent-source-item[data-source-id="${String(photo.id)}"]`);
    if (existing) existing.remove();
    const node = _createRecentPhotoItem(photo, handlers);
    strip.prepend(node);
    if (empty) empty.classList.add('hidden');
}

export function renderRecentPhotos(photos, handlers = {}) {
    const strip = document.getElementById('recentPhotosStrip');
    if (!strip) return;

    const empty = document.getElementById('recentPhotosEmpty');
    strip.innerHTML = "";

    const items = Array.isArray(photos) ? photos : [];
    if (!items.length) {
        if (empty) empty.classList.remove('hidden');
        return;
    }
    if (empty) empty.classList.add('hidden');

    items.forEach((photo) => {
        strip.appendChild(_createRecentPhotoItem(photo, handlers));
    });
}
